import * as React from 'react';
import { InfoBarCustomAction } from '../schema/InfoBarMessageViewState';

export interface InfoBarMessageWithCustomActionProps {
    customAction: InfoBarCustomAction;
    className?: string;
}

const InfoBarMessageWithCustomAction = (props: InfoBarMessageWithCustomActionProps) => {
    const customActionClickHandler = (action: () => void) => {
        return (evt: React.MouseEvent<EventTarget>) => {
            evt.stopPropagation();
            action();
        };
    };

    return (
        <a
            className={props.className}
            href={'javascript:void(0);'}
            onClick={customActionClickHandler(props.customAction.action)}>
            {props.customAction.text}
        </a>
    );
};

export default InfoBarMessageWithCustomAction;
